import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js/object/define-property';
import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import clsx from 'clsx';
import React, { useState, useCallback, useImperativeHandle } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { IconXMarkSmall, IconTickFillSmall } from '@byted-tiktok/tux-icons';
import { genID } from '../../utils/genID.js';
import { TUXPortal } from '../TUXPortal/TUXPortal.js';
import { useTUXContext } from '../TUXProvider/TUXProvider.js';
import { TUXTextWIP } from '../TUXText/TUXText.js';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var toastInstance = null;
var DEFAULT_DURATION = 2000;
var TUXToastView = function TUXToastView(_ref) {
  var _ref$message = _ref.message,
      message = _ref$message === void 0 ? '' : _ref$message,
      icon = _ref.icon;

  var _useTUXContext = useTUXContext(),
      platform = _useTUXContext.platform;

  return /*#__PURE__*/React.createElement("div", {
    className: clsx('tt-toast__container background-color-ToastDefault text-color-ConstTextInverse mx-16 py-8 box-border flex items-center justify-center', Boolean(icon) && 'pe-8', !icon && 'px-8', platform === 'iOS' && 'tt-toast--iOS')
  }, icon && /*#__PURE__*/React.createElement("span", {
    className: "tt-toast__icon mx-8 flex items-center"
  }, icon), /*#__PURE__*/React.createElement(TUXTextWIP, {
    type: "P1-SemiBold",
    className: 'tt-toast__text' + (!icon ? " text-center" : "")
  }, message));
};
var TUXToast = function TUXToast(_ref2) {
  var _ref2$message = _ref2.message,
      message = _ref2$message === void 0 ? '' : _ref2$message,
      icon = _ref2.icon,
      _ref2$isVisible = _ref2.isVisible,
      isVisible = _ref2$isVisible === void 0 ? false : _ref2$isVisible,
      getContainer = _ref2.getContainer;
  return /*#__PURE__*/React.createElement(TUXPortal, {
    getContainer: getContainer
  }, /*#__PURE__*/React.createElement(CSSTransition, {
    in: isVisible,
    timeout: 300,
    classNames: {
      enterActive: 'tt-toast--enter',
      enterDone: 'tt-toast--enter',
      exitActive: 'tt-toast--leave'
    }
  }, /*#__PURE__*/React.createElement(TUXToastView, {
    message: message,
    icon: icon
  })));
};
var TUXToastQueue = /*#__PURE__*/React.forwardRef(function (_props, ref) {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      toastList = _useState2[0],
      setToastList = _useState2[1];

  var add = useCallback(function (config) {
    var key = genID();

    var item = _objectSpread(_objectSpread({}, config), {}, {
      isVisible: true,
      key: key,
      createTime: Date.now()
    });

    var duration = item.duration || DEFAULT_DURATION;
    setToastList(function (currentList) {
      var _context;

      return _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(currentList), [item]);
    });
    setTimeout(function () {
      setToastList(function (l) {
        return _filterInstanceProperty(l).call(l, function (v) {
          return v !== item;
        });
      });
    }, duration);
  }, []);
  useImperativeHandle(ref, function () {
    return {
      add: add
    };
  }, [add]);
  return /*#__PURE__*/React.createElement(TransitionGroup, null, _mapInstanceProperty(toastList).call(toastList, function (conf) {
    return /*#__PURE__*/React.createElement(CSSTransition, {
      key: conf.key,
      timeout: 300,
      classNames: {
        enterActive: 'tt-toast--enter',
        enterDone: 'tt-toast--enter',
        exitActive: 'tt-toast--leave'
      }
    }, /*#__PURE__*/React.createElement(TUXToastView, conf));
  }));
});
TUXToastQueue.displayName = 'TUXToastQueue';

var newInstance = function newInstance(callback) {
  var div = document.createElement('div');
  document.body.appendChild(div);
  var called = false;

  function ref(_toast) {
    if (called) {
      return;
    }

    called = true;
    callback({
      toast: function toast(config) {
        _toast.add(config);
      },
      destroy: function destroy() {
        ReactDOM.unmountComponentAtNode(div);

        if (div.parentNode) {
          div.parentNode.removeChild(div);
        }
      }
    });
  }

  ReactDOM.render( /*#__PURE__*/React.createElement(TUXToastQueue, {
    ref: ref
  }), div);
};

var toast = function toast(config) {
  if (!toastInstance) {
    newInstance(function (inst) {
      toastInstance = inst;
      toastInstance.toast(config);
    });
  } else {
    toastInstance.toast(config);
  }
};

var info = function info(conf) {
  var message;
  var duration = DEFAULT_DURATION;

  if (typeof conf === 'string') {
    message = conf;
  } else {
    message = conf.message;
    conf.duration && (duration = conf.duration);
  }

  toast({
    message: message,
    duration: duration
  });
};

var _ref3 = /*#__PURE__*/React.createElement(IconXMarkSmall, {
  className: "text-color-Negative"
});

var error = function error(conf) {
  var message;
  var duration = DEFAULT_DURATION;

  if (typeof conf === 'string') {
    message = conf;
  } else {
    message = conf.message;
    conf.duration && (duration = conf.duration);
  }

  toast({
    message: message,
    icon: _ref3,
    duration: duration
  });
};

var _ref4 = /*#__PURE__*/React.createElement(IconTickFillSmall, {
  className: "text-color-Positive"
});

var success = function success(conf) {
  var message;
  var duration = DEFAULT_DURATION;

  if (typeof conf === 'string') {
    message = conf;
  } else {
    message = conf.message;
    conf.duration && (duration = conf.duration);
  }

  toast({
    message: message,
    icon: _ref4,
    duration: duration
  });
};

TUXToast.info = info;
TUXToast.error = error;
TUXToast.success = success;

export { TUXToast, TUXToastView };
//# sourceMappingURL=TUXToast.js.map
